export class HubspotValidator {
  private static readonly HUBSPOT_BASE_PATTERN =
    /^(https?:\/\/)?app\.hubspot\.com\//

  static extractId(link: string): {
    type: 'deal' | null
    id: string | null
  } {
    if (!link) return { type: null, id: null }

    try {
      const url = new URL(link.trim())
      const pathParts = url.pathname.split('/').filter((part) => part !== '')

      const findIdAfterSegment = (segment: string): string | null => {
        try {
          const index = pathParts.indexOf(segment)
          if (index !== -1 && index + 1 < pathParts.length) {
            const potentialId = pathParts[index + 1].split('?')[0]
            // Validate that it's a numeric ID
            if (/^\d+$/.test(potentialId)) {
              return potentialId
            }
          }
        } catch (e) {
          // Silent fail - continue to next pattern
        }
        return null
      }

      // Try common HubSpot URL patterns
      let id = findIdAfterSegment('0-3') // Standard HubSpot pattern
      if (id) return { type: 'deal', id }

      id = findIdAfterSegment('deal') // Direct deal URL pattern
      if (id) return { type: 'deal', id }

      return { type: null, id: null }
    } catch (error) {
      return { type: null, id: null }
    }
  }

  static validateLink(link: string): {
    isValid: boolean
    error?: string
  } {
    if (!link.trim()) {
      return {
        isValid: false,
        error: 'Hubspot Deal Link is required.',
      }
    }

    if (!this.HUBSPOT_BASE_PATTERN.test(link)) {
      return {
        isValid: false,
        error: 'Link must be a valid Hubspot Deal URL.',
      }
    }

    const extracted = this.extractId(link)
    if (extracted.type !== 'deal' || !extracted.id) {
      return {
        isValid: false,
        error: 'Please enter a valid Hubspot Deal link format.',
      }
    }

    return { isValid: true }
  }

  static formatLink(dealId: string): string {
    return `https://app.hubspot.com/contacts/7157564/record/0-3/${dealId}`
  }

  static isDealAlreadyExistsError(errorMessage: string): boolean {
    return errorMessage.toLowerCase().includes('deal id already exist')
  }
}
